import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/index',
    name: 'index',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "views" */ '../views/index.vue')
  },
  {
    path: '/message',
    name: 'message',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "views" */ '../views/message.vue')
  },
  {
    path: '/external',
    name: 'external',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "views" */ '../views/external.vue')
  },
  {
    path: '/parentchild',
    name: 'parentPaper',
    component: () => import(/* webpackChunkName: "views" */ '../views/parentPaper.vue')
  },
  {
    path: '/fulltime',
    name: 'fulltimePaper',
    component: () => import(/* webpackChunkName: "views" */ '../views/fulltimePaper.vue')
  },
  {
    path: '/courseSelection',
    name: 'courseSelection',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "views" */ '../views/courseSelection/index.vue'),
    redirect: "/courseSelection/index",
    children: [
      {
        path: '/courseSelection/index',
        name: 'courseSelectionIndex',
        component: () => import(/* webpackChunkName: "views" */ '../views/courseSelection/pages/index.vue')
      },
      {
        path: '/courseSelection/cart',
        name: 'courseSelectionCart',
        component: () => import(/* webpackChunkName: "views" */ '../views/courseSelection/pages/cart.vue')
      },
      {
        path: '/courseSelection/order',
        name: 'courseSelectionOrder',
        component: () => import(/* webpackChunkName: "views" */ '../views/courseSelection/pages/order.vue')
      },
      {
        path: '/courseSelection/order/details',
        name: 'courseSelectionOrderDetails',
        component: () => import(/* webpackChunkName: "views" */ '../views/courseSelection/pages/orderDetails.vue')
      }
    ]
  },
  
  {
    path: '/testpaperst/index',
    name: 'testpaperstIndex',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "views" */ '../views/testpaperst/pages/index.vue')
  },
  {
    path: '/callDataRecord',
    name: 'callDataRecord',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "views" */ '../views/callDataRecord.vue')
  },
]

const VUE_APP_ENV = process.env.VUE_APP_ENV
const option = {
  history: createWebHistory(process.env.BASE_URL),
  routes
}

if (["preview", "production"].includes(VUE_APP_ENV)) {
  option.base = process.env.VUE_APP_BIG_DOMAIN_PATH
}

const router = createRouter(option)

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '卓越教育智能客服系统';
  next();
});

export default router
